import axios from "axios";
import { getCookieConsent } from "../components/CookieBanner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getSessionId = () => {
  let sid = localStorage.getItem("fl_session_id");
  if (!sid) { sid = `s_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`; localStorage.setItem("fl_session_id", sid); }
  return sid;
};

const consented = () => getCookieConsent()?.choice === "accepted";

// Meta Pixel + GA4 (only after cookie consent; scripts injected by TrackingScripts)
export const track = (metaEvent, gaEvent, params = {}) => {
  if (!consented()) return;
  try {
    if (metaEvent && window.fbq) window.fbq("track", metaEvent, params.meta || params);
    if (gaEvent && window.gtag) window.gtag("event", gaEvent, params.ga || params);
  } catch { /* noop */ }
};

export const trackViewShop = (shop) => {
  track("ViewContent", "view_item_list", {
    meta: { content_type: "florist", content_ids: [shop.id], content_name: shop.name, content_category: shop.city },
    ga: { item_list_id: shop.id, item_list_name: shop.name, city: shop.city },
  });
  axios.post(`${API}/analytics/shop-view`, { shop_id: shop.id, session_id: getSessionId(), path: window.location.pathname }).catch(() => {});
};

export const trackSearchCity = (city, found) => {
  track("Search", "search_city", { meta: { search_string: city, content_category: found?.is_fallback ? "uncovered" : "covered" }, ga: { city, covered: !found?.is_fallback, shop_name: found?.shop_name } });
};

export const trackAddToCart = (product, quantity = 1, price) => {
  track("AddToCart", "add_to_cart", {
    meta: { content_type: "product", content_ids: [product.id], content_name: product.name, value: Number(price || product.price || 0) * quantity, currency: "EUR" },
    ga: { currency: "EUR", value: Number(price || product.price || 0) * quantity, items: [{ item_id: product.id, item_name: product.name, price: Number(price || product.price || 0), quantity, item_brand: product.shop_name }] },
  });
  if (product.shop_id) axios.post(`${API}/analytics/engage`, { shop_id: product.shop_id, session_id: getSessionId(), action: "add_to_cart" }).catch(() => {});
};

export const trackEngage = (shopId, action = "product_click") => {
  if (!shopId) return;
  axios.post(`${API}/analytics/engage`, { shop_id: shopId, session_id: getSessionId(), action }).catch(() => {});
};

export const trackPurchase = (orderId, total, items = []) => {
  const key = `fl_purchase_${orderId}`;
  if (!orderId || sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, "1");
  track("Purchase", "purchase", {
    meta: { value: Number(total || 0), currency: "EUR", content_type: "product", content_ids: items.map(i => i.product_id || i.id), num_items: items.reduce((n, i) => n + (i.quantity || 1), 0) },
    ga: { transaction_id: orderId, value: Number(total || 0), currency: "EUR", items: items.map(i => ({ item_id: i.product_id || i.id, item_name: i.name || i.product_name, price: Number(i.price || 0), quantity: i.quantity || 1 })) },
  });
};
